import { MeasurementType } from '../../constants/MeasurementType';
import { PagedRequest } from './PagedRequest';

export default class MeasurementRequest extends PagedRequest<MeasurementRequest> {
  deviceIdentifier: string | null = null;
  measurementType: MeasurementType | null = null;
  measurerId: number | null = null;
  // liste d'ids en CSV : axios sérialiserait un tableau en measurerIds[], que Spring ne binde pas
  measurerIds: string | null = null;
  beginDate: string | null = null;
  endDate: string | null = null;
}
